import type { FC, PropsWithChildren } from 'react';
import React, { useMemo } from 'react';

import type { ThreadIconOptions } from './context';
import { ThreadIconContext, defaultOptions } from './context';

export interface ThreadIconOptionsProviderProps {
  readonly options?: Partial<ThreadIconOptions>;
}

const ThreadIconOptionsProvider: FC<PropsWithChildren<ThreadIconOptionsProviderProps>> = ({ options, children }) => {
  const value = useMemo(() => ({ ...defaultOptions, ...options }), [options]);

  return <ThreadIconContext.Provider value={value}>{children}</ThreadIconContext.Provider>;
};

export default ThreadIconOptionsProvider;
